/*
 * Copyright 2025 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __assign, __rest } from "tslib";
import classNames from "classnames";
import * as React from "react";
import { Classes } from "../../common";
import { DISPLAYNAME_PREFIX } from "../../common/props";
/**
 * Form group component.
 *
 * @see https://blueprintjs.com/docs/#core/components/form-group
 */
export var FormGroup = function (props) {
    var _a;
    var children = props.children, className = props.className, contentClassName = props.contentClassName, disabled = props.disabled, fill = props.fill, helperText = props.helperText, inline = props.inline, intent = props.intent, label = props.label, labelFor = props.labelFor, labelInfo = props.labelInfo, style = props.style, subLabel = props.subLabel, htmlProps = __rest(props, ["children", "className", "contentClassName", "disabled", "fill", "helperText", "inline", "intent", "label", "labelFor", "labelInfo", "style", "subLabel"]);
    var classes = classNames(Classes.FORM_GROUP, Classes.intentClass(intent), (_a = {},
        _a[Classes.DISABLED] = disabled,
        _a[Classes.FILL] = fill,
        _a[Classes.INLINE] = inline,
        _a), className);
    return (React.createElement("div", __assign({ className: classes, style: style }, htmlProps),
        label && (React.createElement("label", { className: Classes.LABEL, htmlFor: labelFor },
            label,
            " ",
            React.createElement("span", { className: Classes.TEXT_MUTED }, labelInfo))),
        subLabel && React.createElement("div", { className: Classes.FORM_GROUP_SUB_LABEL }, subLabel),
        React.createElement("div", { className: classNames(Classes.FORM_CONTENT, contentClassName) },
            children,
            helperText && React.createElement("div", { className: Classes.FORM_HELPER_TEXT }, helperText))));
};
FormGroup.displayName = "".concat(DISPLAYNAME_PREFIX, ".FormGroup");
//# sourceMappingURL=formGroup.js.map